import { CanalFacts } from '../../UI/canal-facts';